import Cookies from 'js-cookie'

const prod = process.env.NODE_ENV === 'production'
const windowEnv = window.Environment ? window.Environment : false
let isDevEnv = false
if (windowEnv === 'dev') {
  isDevEnv = true
}
const isDev = function () {
  return isDevEnv
}

// import { captureMessage, captureException } from "@sentry/browser";
// From https://davidwalsh.name/javascript-debounce-function.
const debounce = function (func, wait, immediate) {
  let timeout
  return function () {
    const context = this
    const args = arguments
    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }
    const callNow = immediate && !timeout
    clearTimeout(timeout)
    timeout = setTimeout(later, wait)
    if (callNow) func.apply(context, args)
  }
}

const logError = function (message, obj = null) {
  if (window.Environment && window.Environment === 'dev') {
    console.log(message, obj)
  } else {
    // captureException(new Error(message, obj));
  }
}

const logMessage = function (message, obj = null) {
  if (window.Environment && window.Environment === 'dev') {
    console.log(message, obj)
  } else {
    // captureMessage(message, obj)
  }
}

// Removes parameter from the URL
const removeParam = function (key, sourceURL) {
  let rtn = sourceURL.split('?')[0]
  let param
  let params_arr = []
  const queryString = sourceURL.indexOf('?') !== -1 ? sourceURL.split('?')[1] : ''
  if (queryString !== '') {
    params_arr = queryString.split('&')
    for (let i = params_arr.length - 1; i >= 0; i -= 1) {
      param = params_arr[i].split('=')[0]
      if (param === key) {
        params_arr.splice(i, 1)
      }
    }
    if (params_arr.length <= 0) {
      rtn = rtn
    } else {
      rtn = `${rtn}?${params_arr.join('&')}`
    }
  }
  return rtn
}

const removeParamLocation = function (key) {
  const updatedUrl = removeParam(key, window.location.href)
  window.history.replaceState('', document.title, updatedUrl)
}

// Function to reinitialize JS after an AJAX call
const reInitModules = function (reinit) {
  const modulesToReinit = reinit.split(',')
  if (isDev()) {
    console.log(`library/index.js - reInitModules - loaded ${reinit}`)
  }
  const moduleElements = document.querySelectorAll('[data-module]')
  for (let i = 0; i < moduleElements.length; i++) {
    const el = moduleElements[i]
    const name = el.getAttribute('data-module')
    if (modulesToReinit.includes(name) || reinit === 'all') {
      if (isDev()) {
        console.log(name)
      }
      const Module = require(`../modules/${name}`).default
      new Module(el)
    }
  }
}

const reInitDeferModules = function (reinit) {
  // const moduleElements = document.querySelectorAll("[data-moduleDefer]");
  // for (let i = 0; i < moduleElements.length; i++) {
  //     const el = moduleElements[i];
  //     const name = el.getAttribute("data-moduleDefer");
  //     if (name === reinit) {
  //         const Module = require(`../modulesDefer/${name}`).default;
  //         new Module(el);
  //     }
  // }
}

// animation sorting based on numeric value of
// data attribute
const handleAnimSort = function (elms) {
  return [].slice.call(elms).sort((a, b) =>
    +a.dataset.anim - +b.dataset.anim)
}

// Change button states on stacks and overlays
const buttonStates = function (elem, state) {
  elem.classList.remove('s-error', 's-ready', 's-loading', 's-disabled')
  if (state === 'loading') {
    elem.classList.add('s-loading')
  } else if (state === 'error') {
    elem.classList.add('s-error')
  } else if (state === 'ready') {
    elem.classList.add('s-ready')
  } else if (state === 'disabled') {
    elem.classList.add('s-disabled')
  }
}

const handleBodyScroll = function (state) {
  const { body } = document
  if (state === 'disabled') {
    body.classList.add('s-scrolling-disabled')
  } else {
    body.classList.remove('s-scrolling-disabled')
  }
}

const getHeight = function (elem) {
  // https://jsfiddle.net/xuumzf9k/1/
  const el_style = window.getComputedStyle(elem)
  const el_display = el_style.display
  const el_position = el_style.position
  const el_visibility = el_style.visibility
  const el_max_height = el_style.maxHeight.replace('px', '').replace('%', '')
  let wanted_height = 0

  // if its not hidden we just return normal height
  if (el_display !== 'none' && el_max_height !== '0') {
    return elem.offsetHeight
  }

  console.log('show elem to get height')
  // the element is hidden so:
  // making the el block so we can measure its height but still be hidden
  elem.style.position = 'absolute'
  elem.style.visibility = 'hidden'
  elem.style.display = 'block'

  wanted_height = elem.offsetHeight

  // reverting to the original values
  elem.style.display = ''
  elem.style.position = ''
  elem.style.visibility = ''
  // elem.style.display = el_display;
  // elem.style.position = el_position;
  // elem.style.visibility = el_visibility;

  return wanted_height
}

const fetchCookieKey = function (cookie, key, isJson = true) {
  let $current = Cookies.get(cookie)

  if (isJson) {
    try {
      JSON.parse($current)
    } catch (e) {
      console.log(e)
      console.log(`resetting ${cookie} due to JSON error`)
      Cookies.set(cookie, {})
    }
  }

  // make sure cookie exists
  if (typeof $current === 'undefined') {
    Cookies.set(cookie, {})
    $current = Cookies.get(cookie)
  }
  // if it does, get it and parse the key
  const $currentDecode = JSON.parse($current)
  if (
    typeof $currentDecode[key] === 'undefined' ||
        $currentDecode[key] === ''
  ) {
    return ''
  }
  return $currentDecode[key]
}
const setCookieKey = function (cookie, key, value) {
  let $current = Cookies.get(cookie)
  if (typeof $current === 'undefined') {
    Cookies.set(cookie, {})
    $current = Cookies.get(cookie)
  }
  const $currentDecode = JSON.parse($current)
  $currentDecode[key] = value
  Cookies.set(cookie, JSON.stringify($currentDecode), { sameSite: 'strict' })
}

const userMotionEnabled = function () {
  const motionQuery = matchMedia('(prefers-reduced-motion)')
  if (motionQuery.matches) {
    return false
  }
  return true
}

// Making all functions available in this
// module to exports that we have made
// so that we can import this module and
// use these functions whenever we want.
export {
  buttonStates,
  removeParam,
  removeParamLocation,
  debounce,
  logError,
  reInitModules,
  reInitDeferModules,
  getHeight,
  handleAnimSort,
  isDev,
  handleBodyScroll,
  setCookieKey,
  fetchCookieKey,
  userMotionEnabled,
}
